module.exports = __webpack_public_path__ + "static/media/p44Logo_circle_white.3b44c75f.svg";